import { GET_CATEGORY_REQUEST, GET_CATEGORY_SUCCESS, GET_CATEGORY_FAIL,
    CREATE_CATEGORY_REQUEST, CREATE_CATEGORY_SUCCESS, CREATE_CATEGORY_FAIL,
    UPDATE_CATEGORY_REQUEST, UPDATE_CATEGORY_SUCCESS, UPDATE_CATEGORY_FAIL,
    DELETE_CATEGORY_REQUEST, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_FAIL} from '../types/categoryTypes'




function getCategoriesReducer( state = { categories: [] }, action) {
    switch (action.type) {
        case GET_CATEGORY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CATEGORY_SUCCESS: 
            return {
                ...state,
                categories: action.payload,
                isLoading: false
            }
        case GET_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateCategoryReducer( state = { updateCategory: {} }, action) {
    switch (action.type) {
        case UPDATE_CATEGORY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_CATEGORY_SUCCESS: 
            return {
                ...state,
                updateCategory: action.payload,
                isLoading: false
            }
        case UPDATE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createCategoryReducer( state = { createCategory: {} }, action) {
    switch (action.type) {
        case CREATE_CATEGORY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_CATEGORY_SUCCESS: 
            return {
                ...state,
                createCategory: action.payload,
                isLoading: false
            }
        case CREATE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function deleteCategoryReducer( state = { deleteCategory: {} }, action) {
    switch (action.type) {
        case DELETE_CATEGORY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_CATEGORY_SUCCESS: 
            return {
                ...state,
                deleteCategory: action.payload,
                isLoading: false
            }
        case DELETE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getCategoriesReducer, updateCategoryReducer, createCategoryReducer, deleteCategoryReducer }